var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"leave":_vm.leave,"enter":_vm.enter}},[_c('div',{attrs:{"id":"loading"}})])}
var staticRenderFns = []

export { render, staticRenderFns }